import { ResourceExplorerPath } from "../../../utils/types/billingExplorer";
import { resourceExplorerStateSelector } from "../../resourceExplorerStateSelector";
import { RootState } from "@/store/store";

export const resourceExplorerPathSelector = (
  state: RootState,
): ResourceExplorerPath[] => {
  return resourceExplorerStateSelector(state).path;
};
